import { render, staticRenderFns } from "./AgreementsComponent.vue?vue&type=template&id=c9673158&scoped=true&lang=pug"
import script from "./AgreementsComponent.vue?vue&type=script&lang=js"
export * from "./AgreementsComponent.vue?vue&type=script&lang=js"
import style0 from "./AgreementsComponent.vue?vue&type=style&index=0&id=c9673158&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9673158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9673158')) {
      api.createRecord('c9673158', component.options)
    } else {
      api.reload('c9673158', component.options)
    }
    module.hot.accept("./AgreementsComponent.vue?vue&type=template&id=c9673158&scoped=true&lang=pug", function () {
      api.rerender('c9673158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AgreementsComponent.vue"
export default component.exports